let apiBase = {
  queryList:'/api/recommendApk/queryPage',                  // 列表
  addRecommendApp:'/api/recommendApk/add',                  //  添加
  importRecommendApp:'/api/recommendApk/import',     //  停用
  deleteRecommendApp:'/api/recommendApk/delete',            // 删除
}
let RecommendAppServerObject = null
class RecommendAppServer{
  constructor(){}
  queryList(data={}){
    return $http({
      url: apiBase.queryList,
      method: 'post',
      data: data,
    })
  }
  addRecommendApp(data={}){
	  return $http({
      method: 'post',
      url: apiBase.addRecommendApp,
      data:data
    })
   }

  importRecommendApp(data={}){
    return $http({
      url: apiBase.importRecommendApp,
      method: 'post',
      data: data,
    })
  }

  deleteRecommendApp(data={}){
    return $http({
      url: apiBase.deleteRecommendApp,
      method: 'post',
      data: data,
    })
  }

}
function singleRecommendAppServer(){
  if(RecommendAppServerObject === null){
    RecommendAppServerObject = new RecommendAppServer()
  }
  return RecommendAppServerObject
}
export default singleRecommendAppServer()
